import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuControlsOption} from '@Components/contextual-menu/components/contextual-menu-controls-option';
import {AlignType} from '@PosterWhiteboard/page/alignment.class';
import styles from './item-alignment-options.module.scss';
import {useShouldDisableGroupMovementOptions} from '@Hooks/poster-editor/useShouldDisableGroupMovementOptions';

export function ItemAlignmentOptions(): ReactElement<any> {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  const isLocked = useShouldDisableGroupMovementOptions();

  const onClickHandler = (clickedId: AlignType): void => {
    currentPage?.activeSelection?.alignment?.alignItems(clickedId);
  };

  return (
    <ContextualMenuControlsOption
      id="item-alignment-options"
      onClick={onClickHandler}
      containerClassName={styles.itemContainer}
      wrapItems
      data={[
        {
          id: AlignType.LEFT,
          icon: 'icon-left-align-on-canvas',
          text: window.i18next.t('pmwjs_left'),
          className: styles.items,
          disabled: isLocked,
        },
        {
          id: AlignType.HORIZONTAL,
          icon: 'icon-center-h-align-on-canvas',
          className: styles.items,
          text: window.i18next.t('pmwjs_middle'),
          disabled: isLocked,
        },
        {
          id: AlignType.RIGHT,
          icon: 'icon-right-align-on-canvas',
          className: styles.items,
          text: window.i18next.t('pmwjs_right'),
          disabled: isLocked,
        },
        {
          id: AlignType.TOP,
          icon: 'icon-top-align-on-canvas',
          className: styles.items,
          text: window.i18next.t('pmwjs_top'),
          disabled: isLocked,
        },
        {
          id: AlignType.VERTICAL,
          icon: 'icon-center-v-align-on-canvas',
          className: styles.items,
          text: window.i18next.t('pmwjs_center'),
          disabled: isLocked,
        },
        {
          id: AlignType.BOTTOM,
          icon: 'icon-bottom-align-on-canvas',
          className: styles.items,
          text: window.i18next.t('pmwjs_bottom'),
          disabled: isLocked,
        },
        {
          id: AlignType.CENTER,
          icon: 'icon-core-on-canvas',
          className: styles.items,
          text: window.i18next.t('pmwjs_core'),
          disabled: isLocked,
        },
      ]}
    />
  );
}
